class PerformanceController {
  public username: string;

  /** @ngInject */
  constructor(private $http: angular.IHttpService, private $cookies: angular.cookies.ICookiesService) {
    this.username = $cookies.get('username');
  }
}

export const performance: angular.IComponentOptions = {
  template: require('./performance.html'),
  controller: PerformanceController
};



// WEBPACK FOOTER //
// ./src/app/performance/performance.ts